module.exports = __webpack_public_path__ + "static/media/example3.53671833.gif";